import React from "react";
import cn from "classnames";
import { Field, useField, useFormikContext } from "formik";

import styles from "./styles.module.scss";

const FormikRadioField = ({ label, id, labelClasses, isUnClickable = false, ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField({ name: props.name });

    const handleClick = () => {
        if (props.value === field.value && isUnClickable) {
            setFieldValue(props.name, null);
        }
    };

    return (
        <>
            <Field
                className={styles.radio}
                component="input"
                type="radio"
                id={id}
                onClick={handleClick}
                {...props}
            />
            <label className={cn(styles.label, labelClasses)} htmlFor={id}>
                {label}
            </label>
        </>
    );
};

export default FormikRadioField;
